import React from 'react';

/**
 * Overview strip for the users list: total (anchor), platform mix (with a
 * proportion bar), the all-mobile count and the watch split. Reads the `statastics` object
 * returned by /admin/api/get-user. Numbers use tabular figures + thousands
 * separators for scannability.
 *
 * Props: { statastics, totalItem }
 */
const n = (v) => Number(v ?? 0);
const fmt = (v) => n(v).toLocaleString();

const UsersSummaryCards = ({ statastics = {}, totalItem = 0 }) => {
  const android = n(statastics.android_users);
  const ios = n(statastics.ios_users);
  const platTotal = android + ios;
  const androidPct = platTotal ? Math.round((android / platTotal) * 100) : 0;
  const iosPct = platTotal ? 100 - androidPct : 0;

  return (
    <div className="uv-overview" data-testid="users-summary">
      <div className="uv-ov-primary">
        <span className="uv-ov-label">Total users</span>
        <span className="uv-ov-total tnum">{fmt(totalItem)}</span>
      </div>

      <div className="uv-ov-divider" aria-hidden="true" />

      <div className="uv-ov-stat uv-ov-stat--platform">
        <span className="uv-ov-label">Platform</span>
        <div className="uv-ov-bar" role="img" aria-label={`Android ${androidPct}%, iOS ${iosPct}%`}>
          <span className="uv-ov-bar__seg uv-ov-bar__seg--android" style={{ width: `${androidPct}%` }} />
          <span className="uv-ov-bar__seg uv-ov-bar__seg--ios" style={{ width: `${iosPct}%` }} />
        </div>
        <div className="uv-ov-legend">
          <span><i className="uv-dot uv-dot--android" />Android <b className="tnum">{fmt(android)}</b> <em>{androidPct}%</em></span>
          <span><i className="uv-dot uv-dot--ios" />iOS <b className="tnum">{fmt(ios)}</b> <em>{iosPct}%</em></span>
        </div>
      </div>

      <div className="uv-ov-divider uv-ov-divider--group" aria-hidden="true" />

      {/* Mobile and Watch travel together: when the strip wraps they move as one row, so
          the two labels and the two figures always stay side by side and aligned. */}
      <div className="uv-ov-group">
        {/* One figure: every member in the filtered set, with or without a mobile app version. */}
        <div className="uv-ov-stat" data-testid="users-summary-mobile">
          <span className="uv-ov-label">Mobile</span>
          <div className="uv-ov-pair">
            <span><b className="tnum">{fmt(statastics.mobile_users)}</b></span>
          </div>
        </div>

        <div className="uv-ov-divider" aria-hidden="true" />

        <div className="uv-ov-stat" data-testid="users-summary-watch">
          <span className="uv-ov-label">Watch</span>
          <div className="uv-ov-pair">
            <span><b className="tnum">{fmt(statastics.with_watch_users)}</b><em>with</em></span>
            <span><b className="tnum">{fmt(statastics.without_watch_users)}</b><em>without</em></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsersSummaryCards;
